import React from 'react';
import {
    Edit,
    SimpleForm,
    Toolbar,
    TextField,
    DateField,
    SelectInput
} from 'react-admin';
import CancelButton from '../common/CancelButton';
import SaveButton from '../common/SaveButton';
import OrderedList from './OrderedList';
import { Field } from 'redux-form';

const styles = {
    text: { width: '20em' },
};

const EditToolbar = props => (
    <Toolbar {...props} >
        <SaveButton />
        <CancelButton />
    </Toolbar>
);

const TerminalEdit = props => (
    <Edit  {...props}>
        <SimpleForm toolbar={<EditToolbar />} submitOnEnter={false}>
            <TextField source="name" />
            <TextField source="appName" />
            <TextField source="appVersion" />
            <SelectInput source="status" choices={[
                { id: 0, name: 'resources.terminals.enums.status.registered' },
                { id: 3, name: 'resources.terminals.enums.status.refused' },
            ]} />
            <DateField source="lastAccessDateTime" showTime />
            <TextField source="id" style={styles.text} />
            <Field name="resources" component={OrderedList} />
        </SimpleForm>
    </Edit>
);

export default TerminalEdit;